import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { ApprovalTypeRepository } from '@/store/approval-type-state/approval-type-state.repository';

interface IgetApprovalTypeDataTableStructureProps {
  store: ApprovalTypeRepository;
  rowActions?: DataTableRowActions;
  createAction: () => void;
  enableServerActions?: boolean;
  serverQuery?: any;
}

export const getApprovalTypeDataTableStructure = ({
  store,
  rowActions,
  enableServerActions,
  serverQuery,
  createAction,
}: IgetApprovalTypeDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.approvalType.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const libelleColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.approvalType.table.libelle',
    accessorKey: 'libelle',
    variant: DataTableColumnVariant.TEXT,
  };
  const organismeDeDeliveranceAgrementsColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.approvalType.table.organismeDeDeliveranceAgrements',
    accessorKey: 'organismeDeDeliveranceAgrements.description',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: 'settings.approvalType.table.singular',
    plural: 'settings.approvalType.table.plural',
    columns: [idColumn, libelleColumn, organismeDeDeliveranceAgrementsColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.set('serverState', {
        libelle: row.libelle,
        organismeDeDeliveranceAgrementsId: row.organismeDeDeliveranceAgrements.id,
      });
      store.set('dto', {
        libelle: row.libelle,
        organismeDeDeliveranceAgrementsId: row.organismeDeDeliveranceAgrements.id,
      });
      store.set('approvalTypeSelected', {
        name: row.organismeDeDeliveranceAgrements.description,
        code: row.organismeDeDeliveranceAgrements.id,
      });
    },
    createAction,
    rowActions,
    enableServerActions,
    serverQuery,
  };
};
